var BarDirectionItem = /** @class */ (function () {
    function BarDirectionItem(value, name) {
        this.name = '';
        this.value = value;
        this.name = name;
    }
    return BarDirectionItem;
}());
export { BarDirectionItem };
